import React from "react";
import EdgeVisaCreditCard from "./components/EdgeVisaCreditCard";
import EdgeUpiRupayCreditCard from "./components/EdgeUpiRupayCreditCard";
import NavBar from "./components/NavBar";
import "./App.css";
import { Route, Routes } from "react-router";

function App() {
  return (
    <div className="App font-manrope bg-gt5">
      <NavBar />
      <Routes>
        {/* Both routes show Edge VISA Credit Card for now */}
        <Route index element={<EdgeUpiRupayCreditCard />} />
        <Route path="/edge-visa-credit-card" element={<EdgeVisaCreditCard />} />

        <Route
          path="/edge-upi-rupay-credit-card"
          element={<EdgeUpiRupayCreditCard />}
        />
      </Routes>
    </div>
  );
}

export default App;
